import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

// Japanese views
import TopJa from '@/views/ja/Top.vue'
import CVJa from '@/views/ja/CV.vue'
import PublicationJa from '@/views/ja/Publication.vue'
import PresentationJa from '@/views/ja/Presentation.vue'
import NoteJa from '@/views/ja/Note.vue'
import LinkJa from '@/views/ja/Link.vue'

// English views
import TopEn from '@/views/en/Top.vue'
import CVEn from '@/views/en/CV.vue'
import PublicationEn from '@/views/en/Publication.vue'
import PresentationEn from '@/views/en/Presentation.vue'
import LinkEn from '@/views/en/Link.vue'

const routes: Array<RouteRecordRaw> = [
  // Japanese
  {
    path: '/',
    name: 'top',
    component: TopJa
  },
  {
    path: '/cv',
    name: 'cv',
    component: CVJa
  },
  {
    path: '/publication',
    name: 'publication',
    component: PublicationJa
  },
  {
    path: '/presentation',
    name: 'presentation',
    component: PresentationJa
  },
  {
    path: '/note',
    name: 'note',
    component: NoteJa
  },
  {
    path: '/link',
    name: 'link',
    component: LinkJa
  },
  // English
  {
    path: '/top_en',
    name: 'top_en',
    component: TopEn
  },
  {
    path: '/cv_en',
    name: 'cv_en',
    component: CVEn
  },
  {
    path: '/publication_en',
    name: 'publication_en',
    component: PublicationEn
  },
  {
    path: '/presentation_en',
    name: 'presentation_en',
    component: PresentationEn
  },
  {
    path: '/link_en',
    name: 'link_en',
    component: LinkEn
  },
  // Etc: redirect to the top page
  {
    path: '/:paths(.*)*',
    name: 'nothing',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
